import { useAuth } from '@iamexperiences/feature-auth';

const isEmptyOrUndefined = (obj: any): obj is undefined | null | '' => {
  return obj === undefined || obj === null || obj === '';
};

export const useIsInternalUser = (): boolean => {
  const { auth } = useAuth();
  const user = auth.user;
  return user ? !isEmptyOrUndefined(user.objectId) : false;
};
